import React from 'react'
import { connect } from 'react-redux'
import { saveAs } from 'file-saver'
import { IconButton } from '@material-ui/core'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import { saveDetallePdf } from '../actions'

function DescargaPdf (props) {
  const { url, filename } = props

  const savePdf = () => {
    props.saveDetallePdf()
    saveAs(url, filename)
  }

  return (
    <IconButton onClick={savePdf}>
      <PictureAsPdfIcon color='primary' fontSize='default' />
    </IconButton>
  )
}

const mapActionsToProps = {
  saveDetallePdf
}

const withRedux = connect(null, mapActionsToProps)

export default withRedux(DescargaPdf)
